import React from 'react';
import styled from 'styled-components';
import LogoLoader from '../LogoLoader';

const LoadingOverlay = styled.div`
  /* fullscreen: the sign-in gate has no positioned parent, so cover the viewport itself. */
  position: ${(p) => (p.$fullscreen ? 'fixed' : 'absolute')};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #f9fbff 0%, #f5f8fd 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

const ImavenLoadingScreen = ({ fullscreen = false, message = '' }) => {
    return (
        <LoadingOverlay $fullscreen={fullscreen}>
            <LogoLoader size={200} message={message} />
        </LoadingOverlay>
    );
}

export default ImavenLoadingScreen;